import React from 'react';
import ProjectHeader from '../ProjectHeader';
import './ProjectPage.css'; // Custom styles for this project

const CoT = ({ project }) => {
  // Fallback data if project is not passed as prop
  
  return (
    <div className="cot-page">
      <ProjectHeader 
        title={project.title}
        date={project.date}
        featured={project.featured}
      />
      
      <div className="project-content">
        <p>
        Many Chain of Thought Reasoning models think too much. We've <a href="https://novasky-ai.github.io/posts/reduce-overthinking/" target="_blank" rel="noopener noreferrer">seen</a> instances of models iterating over
        absolute nonsense. However, these reasoning models have proven to be incredibly powerful, so I didn't want to necessarily limit their thinking process. They're still working on it!
        </p>
        <p>
            I came up with Compression of Thought, where the model learns to compress prompts purely through a reward signal. This addresses two main issues:
            <ul>
                <li>Reasoning models iterate through unnecessary information, so we should try to minimize unnecessary information in our prompts</li>
                <li>Input tokens are directly correlated with computational cost</li>
                
            </ul>
            The choice to compress prompts purely through a reward signal was a personal choice guided by previous research. Previous works that look to compress prompts
            utilize strategies that:
            <ul>
                <li>Are uninterpretable</li>
                <li>Instruct too much</li>
                <li>Don't translate to other models</li>
            </ul>
            By choosing to fine tune using only the reward signal, we can see what the model actually cares about, without instruction from the user. This can also be applied to any arbitrary model,
            it is agnostic to the original model. It ended up working pretty well! LLaMA models learned to extract key facts like a good note-taker, while OLMo models developed question-anticipation strategies.
            Models achieved 88+ token reductions while maintaining accuracy, and the whole approach opened up interesting questions about AI interpretability. Those questions will be addressed in a project I am working on currently!


        </p>
        <p>
            Visit the links to see more!
        </p>

      <section className="links-section" >
        <h3>Project Links</h3>
        <div className="project-links" >
            <a href="https://github.com/lanpouthakoun/promptcompression" 
            target="_blank" 
            rel="noopener noreferrer"
            >
            View Source Code
            </a>
            <a href="/files/cot/Compression-Of-Thought.pdf" 
                target="_blank" 
                rel="noopener noreferrer"
            >
            View Paper
            </a>
        </div>
        </section>
      </div>
    </div>
  );
};

export default CoT;

